import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { AuthService } from '../auth/services/auth.service';
import { Observable, of } from 'rxjs';
import { Router } from "@angular/router";
import { tap } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import { JSEncrypt } from 'jsencrypt';

@Injectable()

export class AuthInterceptor implements HttpInterceptor {
    private publicKey: string = `-----BEGIN PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqFk94rdfXR9NBkNh44v3
    Jke5lYmd9Tdb3jsQduMhHFlTi2+qLjBnaiOzYQbDHnN8MKnDSI/HOewBfX0UOAhw
    S5rYO/MfpFnehylkCW0fttD7rP/CM1ZD7sQt+Xs8KgDj/7uLMy1Bw1KhEHRdND44
    mBf9LIubtbv8NY4LBPyJUrTbcXpNqFDicVMN81Mq1hPrq0udqoBInaEkI+beCVWN
    dHKHqeybmlkvs23+zGktp+hN0hlmxug78co5yJB4MT9ErvJAqOy0Pz93hNYoI7Nj
    hwPf9za0m5VhF3kytwwNF8xue3gDH0wDXxhlEu+wGakto6Z+TJ6siELI1atiqTuH
    gwIDAQAB
    -----END PUBLIC KEY-----`;
    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        let token = localStorage.getItem('token');
        let lang = localStorage.getItem('lang');
        const specialParam = request.headers.get('X-Special-Param');
        const encryptedData = this.newEncryptJson(request.body, specialParam);
        if (token) {
            request = request.clone({
                headers: request.headers.delete('X-Special-Param'),
                body:encryptedData,
                setHeaders: {
                    Authorization: "Basic " + window.btoa("3xaUser!@3#:9raPass@3!)#@done"),
                    'x-access-token': token,
                    'lang': lang ? lang : ''
                }
            })
        } else {
            request = request.clone({
                body:encryptedData,
                setHeaders: {
                    Authorization: "Basic " + window.btoa("3xaUser!@3#:9raPass@3!)#@done")
                }
            })
        }


        return next.handle(request).pipe(
            tap(
                event => {
                    if (event instanceof HttpResponse) {

                        if (event.body.status == 401 || event.body.status == 403) {

                            this.authService.logout();
                            alert('Please click on sign in to sign again.');
                        }
                    }
                },
                error => {
                     
                    if (error.status == 500) {
                        if (error.error.errorCode == 101 || error.error.errorCode == 102 || error.error.errorCode == 104) {
                            if (error.error.errorCode == 101) {
                                alert('You are already logged in with different device.');
                            }
                        }
                        alert(error?.error?.message ? error?.error?.message : 'Some error happened on server. Please try again!!!..');
                        return;
                    }else if (error.status == 401 || error.status == 403) {
                        
                        this.authService.logout();
                        this.router.navigate(['/'])
                    }
                     else {
                        alert(error?.error?.message ? error?.error?.message : 'Some error happened on server. Please try again!!!..');
                        this.router.navigate(['/'])
                    }
                }
            )
        );
    }

    newEncryptJson(data: any, isDelete:any) {
            
        if(isDelete == 'delete'){
            return data;
        }
        if (!this.publicKey) {
            throw new Error('Public key not loaded.');
        }

        try {
            const jsonData = JSON.stringify(data);

            const aesKey = CryptoJS.lib.WordArray.random(16); 
            const aesIv = CryptoJS.lib.WordArray.random(16);   

            const encryptedPayload = CryptoJS.AES.encrypt(jsonData, aesKey, {
                iv: aesIv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }).toString(); 

            const rsa = new JSEncrypt();
            rsa.setPublicKey(this.publicKey);

            const encryptedKey = rsa.encrypt(aesKey.toString(CryptoJS.enc.Base64)); // AES key is Base64-encoded
            const encryptedIv = rsa.encrypt(aesIv.toString(CryptoJS.enc.Base64));   // AES IV is Base64-encoded

            if (!encryptedKey || !encryptedIv) {
                throw new Error('RSA encryption failed.');
            }

            return {
                alphaXyz: encryptedKey,     // RSA-encrypted AES key (Base64-encoded)
                sigmaBlt: encryptedIv,      // RSA-encrypted AES IV (Base64-encoded)
                kappaRmn: encryptedPayload, // AES-encrypted data (Base64-encoded)
            };
        } catch (error) {
            throw new Error('Encryption process encountered an error.');
        }
    }
}
